/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkStatusTimespan } from './networkStatusTimespan';
import { Comment } from './comment';
import { DataPlanTimespan } from './dataPlanTimespan';
import { StringTimespan } from './stringTimespan';
import { LongTimespan } from './longTimespan';
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';
import { ComProviderTimespan } from './comProviderTimespan';
import { CollarBuild } from './collarBuild';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface CollarDto { 
    _class: string;
    airtimeNetworkStatusChangeRequested?: CollarDto.AirtimeNetworkStatusChangeRequestedEnum;
    batteryTimeline?: Array<StringTimespan>;
    bootloaderVersionId?: string;
    buildInProduction?: CollarBuild;
    color?: string;
    comId?: string;
    comIdTimeline?: Array<StringTimespan>;
    comProviderTimeline?: Array<ComProviderTimespan>;
    comType?: CollarDto.ComTypeEnum;
    commandCount?: number;
    comments?: Array<Comment>;
    currentBuild?: CollarBuild;
    dataPlanTimeline?: Array<DataPlanTimespan>;
    deviceTypeId?: string;
    externalDropOffId?: number;
    firmwareVersionId?: string;
    gpsPlusDevice?: boolean;
    id?: number;
    idDevice?: number;
    insertTs?: string;
    internalDropOffId?: number;
    knownToSendBrokenMessages?: boolean;
    lastReceivedCommandTime?: string;
    lowBatteryStatus?: CollarDto.LowBatteryStatusEnum;
    networkStatusTimeline?: Array<NetworkStatusTimespan>;
    nfcTagUid?: string;
    parameterDataList?: Array<ParameterData>;
    paymentAccountTimeline?: Array<LongTimespan>;
    pcbTypeId?: string;
    previousBuilds?: Array<CollarBuild>;
    replacedById?: number;
    roofTestCompleted?: string;
    schedules?: Array<Schedule>;
    testDevice?: boolean;
    updateTs?: string;
    userSubsystemVisibility?: Array<boolean>;
    vhfBeaconTransmitterId?: number;
    virtualFenceConstructionRules?: Array<VirtualFenceConstructionRule>;
    warranty?: string;
}
export namespace CollarDto {
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const LowBatteryStatusEnum = {
        Alert: 'ALERT',
        Resolved: 'RESOLVED'
    } as const;
    export type LowBatteryStatusEnum = typeof LowBatteryStatusEnum[keyof typeof LowBatteryStatusEnum];
}


export type AirtimeNetworkStatusChangeRequestedEnum = typeof CollarDto.AirtimeNetworkStatusChangeRequestedEnum[keyof typeof CollarDto.AirtimeNetworkStatusChangeRequestedEnum];
export type LowBatteryStatusEnum = typeof CollarDto.LowBatteryStatusEnum[keyof typeof CollarDto.LowBatteryStatusEnum];
